import { Toaster } from '~/DesignSystem/components/sonner'
import { cn } from '~/DesignSystem/lib/utils'

const Layout: React.FC<React.ComponentProps<'div'>> = ({ children, className }) => {
  return (
    <div className={cn('flex flex-col min-h-dvh w-full min-w-xs bg-white', className)}>
      <Toaster position="top-center" />
      {children}
    </div>
  )
}

const LayoutHeader: React.FC<React.ComponentProps<'div'>> = ({ children, className }) => {
  return <div className={cn('px-4 py-2 bg-neutral-50', className)}>{children}</div>
}

const LayoutContent: React.FC<React.ComponentProps<'div'>> = ({ children, className }) => {
  return <div className={cn('flex-1 p-4', className)}>{children}</div>
}

const LayoutFooter: React.FC<React.ComponentProps<'div'>> = ({ children, className }) => {
  return <div className={cn('px-4 p-4 border-t border-t-neutral-100', className)}>{children}</div>
}

export default Layout
export { LayoutContent, LayoutFooter, LayoutHeader }
